/**
 * Frontend operational telemetry for skin analysis flow.
 * Counters are in-memory; inspect via getSkinTelemetrySnapshot() or window.__SKIN_TELEMETRY__.
 */

const COUNTERS = {
  retry: 0,
  timeout: 0,
  reconnect: 0,
  retry_exhausted: 0,
  abort: 0,
  report_load_failure: 0,
  save_analysis_retry: 0,
};

const RECENT_MAX = 25;
const recentEvents = [];

function publishSnapshot() {
  if (typeof window !== 'undefined') {
    window.__SKIN_TELEMETRY__ = getSkinTelemetrySnapshot();
  }
}

export function recordSkinTelemetry(event, details = {}) {
  const key = String(event || 'unknown');
  if (Object.prototype.hasOwnProperty.call(COUNTERS, key)) {
    COUNTERS[key] += 1;
  } else {
    COUNTERS[key] = (COUNTERS[key] || 0) + 1;
  }

  const payload = { event: key, ts: new Date().toISOString(), ...details };
  recentEvents.unshift(payload);
  if (recentEvents.length > RECENT_MAX) recentEvents.length = RECENT_MAX;

  if (key === 'retry_exhausted' || key === 'timeout' || key === 'report_load_failure') {
    console.warn('[skin-telemetry]', payload);
  } else {
    console.info('[skin-telemetry]', payload);
  }
  publishSnapshot();
}

export function getSkinTelemetrySnapshot() {
  return {
    counters: { ...COUNTERS },
    recent: [...recentEvents],
  };
}

export function resetSkinTelemetryForTests() {
  Object.keys(COUNTERS).forEach((k) => { COUNTERS[k] = 0; });
  recentEvents.length = 0;
  publishSnapshot();
}

publishSnapshot();
